import { render, staticRenderFns } from "./VisitorStatement.vue?vue&type=template&id=6b81f8ff&scoped=true&"
import script from "./VisitorStatement.vue?vue&type=script&lang=js&"
export * from "./VisitorStatement.vue?vue&type=script&lang=js&"
import style0 from "./VisitorStatement.vue?vue&type=style&index=0&id=6b81f8ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81f8ff",
  null
  
)

export default component.exports